<template>
  <div v-if="isAuthorized" class="mf-viewer-wrapper">
    <ViewerMainHeader 
      :title="title"
      :bimplusTeamSlug="bimplusTeamSlug"
      :bimplusProjectId="bimplusProjectId"
      :isolateView="isolateView"
      :setModelVisible="setModelVisible"
      :enableAddObjects="enableAddObjects"
      @back="$emit('back')"
      @addItemView="(val) => $emit('addItemView', val)"/>
    <ViewerSideMenu v-if="!isolateView"
      @setProjectModelActive="isProjectModelActive = !isProjectModelActive" />
    <!-- <div class="column nav-bimplus">
      <div class="columns">
        <div class="column">
          <h3 class="has-text-weight-semibold is-size-6 has-text-primary">MANUFACTON PROJECT</h3>
          <h4 class="has-text-weight-semibold is-size-6 has-text-black-bis">{{ mFactProjectname }}</h4>
        </div>
        <div class="column is-flex is-align-items-center is-justify-content-flex-end">
          <div class="is-divider-vertical"></div>
          <button class="button px-0 has-text-black-bis"><i class="icon-tablecolumns"></i></button>
          <div class="is-divider-vertical"></div>
          <button class="button pointer px-0 has-text-black-bis" @click="resetView"><i class="icon-activityhistory is-size-3"></i></button>
          <div class="is-divider-vertical"></div>
          <div>
            <button class="button p-0 has-text-black-bis" @click="toggleFilterModal">
              <i class="icon-importexcel"></i>
            </button>
            <BimPlusFilter 
              :visible="showFilters"
              :projectId="projectId"
              :models="projectModels"
              :bimplusProjectId="bimplusProjectId"
              @close-modal="showFilters = false">
            </BimPlusFilter>
          </div>
          <div class="is-divider-vertical"></div>
          <div>
            <button class="button pointer px-0 has-text-black-bis" @click="toggleModelSettingsModal">
              <i class="icon-activityhistory is-size-3"></i>
            </button>
            <ModelSettings
              :visible="showModelSettings"
              @close-modal="showModelSettings = false">
            </ModelSettings>
          </div> -->
          
          <!-- <div class="is-divider-vertical"></div>
          <button class="button pointer px-0 has-text-black-bis"><i class="icon-activityhistory is-size-3"></i></button>
          <div class="is-divider-vertical"></div>
          <button class="button p-0 has-text-black-bis"><i class="icon-importexcel"></i></button>
        </div>
      </div>
    </div> -->
    <div class="bimplus-viewer" :class="isolateView ? 'hide-sidemenu' : ''">
      <div class="column">
       <div class="columns">
        <div class="column">
          <div id="maninViewportContainer" style="width: 100%; height: 100vh;">
            <ProjectModelNavigator v-if="projectModelsFetched && !isolateView"
              v-show="isProjectModelActive"
              :models="projectModels"
              :isFooterVisible="['createOrder', 'addModelObjects'].includes(title.id)"
              :bimplusProjectId="bimplusProjectId"
              :projectId="projectId"
              :setModelVisible="setModelVisible"
              :guidsList="guidsList"
              :addObjectsBySelection="addObjectsBySelection">
            </ProjectModelNavigator>
            <div id="objectProperties" class="object-viewer">
              <div>
                <h3 class="is-size-3 has-text-black-bis p-3">Object Properties</h3>
              </div>
              <div>
                <iframe
                  title="Object properties"
                  id="bimplusObjectProperties"
                  class="objectPropertiesIFrame"
                  ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
  <div v-else class="refresh-login is-size-4">
    <div class="has-text-weight-bold">
      Your BIMPLUS token got expired. Kindly re-authorize.
    </div>
    <div>
      <button
        @click="refreshToken">
        Refresh Token
      </button>
    </div>
  </div>
  <o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
</template>

<script>
import {reactive, onBeforeMount, toRefs, onMounted} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import _ from 'lodash';
import ProjectsApi from '@/models/Projects';
import bimplusViewer from './bimplusViewer';
import ViewerMainHeader from '../../components/bimplus/ViewerMainHeader.vue';
import ViewerSideMenu from '../../components/bimplus/ViewerSideMenu.vue';
import ProjectModelNavigator from '../../components/bimplus/ProjectModelNavigator.vue';
import BimPlusFilter from '../../components/bimplus/BimPlusFilter.vue';
import ModelSettings from '../../components/bimplus/ModelSettings.vue';
import BimPlus from '../../models/BimPlus';
import $ from 'jquery';


window.$ = $;

export default {
  name: 'BimPlusViewer',
  props: {
    projectId: {
      type: String,
      default: '',
    },
    guids: {
      type: Array,
      default: () => [],
    },
    isolateView: {
      type: Boolean,
      default: false,
    },
    modelName: {
      type: String,
      default: ''
    },
    orderName: {
      type: String,
      default: '',
    },
    addObjectsBySelection: {
      type: Boolean,
      default: false
    },
    modelId: {
      type: String,
      default: ''
    },
    disableObjectProperties: {
      type: Boolean,
      default: false
    }
  },
  components: {ProjectModelNavigator, BimPlusFilter, ModelSettings, ViewerMainHeader, ViewerSideMenu},
  setup(props) {
    const{ projectId }  = props;
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const data = reactive ({
      mFactProjectname: '',
      mFactProject: {},
      bimplusTeamSlug: '',
      bimplusProjectId: '',
      projectModels: [],
      isAuthorized: true,
      showFilters: false,
      showModelSettings: false,
      title: {
        heading: '',
        value: '',
        id: '',
      },
      isProjectModelActive: true,
      isLoading: false,
      projectModelsFetched: false,
      setModelVisible: false,
      guidsList: [],
      enableAddObjects: false
    }); 

    const getMFactProject = async () => {
      data.mFactProject = await ProjectsApi.get(projectId);
      if(data.mFactProject !== null) {
       data.mFactProjectname = data.mFactProject.name;
       data.bimplusTeamSlug = data.mFactProject.projectSettings[0]?.bimplusSync?.team?.id;
       data.bimplusProjectId = data.mFactProject.projectSettings[0]?.bimplusSync?.project?.id;
      }
    };

    const refreshToken = () => {
      router.push({
        name: 'user-settings',
        params: {
          refreshToken: true,
        }
      });
    };

    const resetView = () => {
      bimplusViewer.resetView();
    };

    const toggleFilterModal = () => {
      data.showFilters = !data.showFilters;
    };

    const toggleModelSettingsModal = () => {
      data.showModelSettings = !data.showModelSettings;
    };

    onBeforeMount(async () => {
      if(_.isEmpty(store.state.bimplus.access_token || store.state.bimplus.refresherror)) {
        data.isAuthorized = false;
        return;
      }
      const params = {
        token: store.state.bimplus.access_token,
        projectId: projectId
      };

      try{
        const synchGuids = BimPlus.syncGuids(params);
      } catch(err) {
        console.log(err);
      }

    });

    const resizeViewer = () => {
      bimplusViewer.resizeViewer(window.innerWidth, window.innerHeight);
    };

    onMounted( async () => {
      try {
        data.isLoading = true;
        await getMFactProject();
        const routeFrom = _.get(route.query, 'from', '');
        if (routeFrom === 'projectSettings') {
          data.title.heading = 'MANUFACTON PROJECT';
          data.title.value = data.mFactProjectname;
          data.title.id = routeFrom;
        }
        if (routeFrom === 'createOrder') {
          data.title.heading = 'CREATE PRODUCTION ORDERS';
          data.title.value = 'SELECT PROJECT MODEL';
          data.title.id = routeFrom;
        }
        if(routeFrom === 'addModelObjects') {
          data.title.heading = 'ADD MODEL OBJECTS/OBJECT GROUPS TO ORDER';
          data.title.value = 'SELECT PROJECT MODEL';
          data.title.id = routeFrom;
        }
        if (props.isolateView) {
          data.title.heading = `<span class="has-text-weight-semibold has-text-dark">BIMPLUS MODEL: </span>${props.modelName}`;
          data.title.value = `<span class="has-text-weight-semibold has-text-grey mr-3">MODEL OBJECT: </span>${props.orderName}`;
          data.title.id = routeFrom;
        }
        if (props.addObjectsBySelection) {
          data.title.heading = 'ADD MODEL OBJECTS/OBJECT GROUPS TO ORDER';
          data.title.value = `<span class="has-text-weight-semibold has-text-grey mr-3">PRODUCTION ORDER: </span>${props.orderName}`;
          data.title.id = 'addObjectsBySelection';
        }

        await bimplusViewer.LoadViewer(data.bimplusTeamSlug, data.bimplusProjectId, props.disableObjectProperties, data);
        data.projectModels = await bimplusViewer.getProjectModels(data.bimplusProjectId);
        
        if (props.isolateView && props.guids.length) {
          const modelId = _.get(route.query, 'modelId') || props.modelId || '';
          if (modelId) {
            const model = _.find(data.projectModels, {id : modelId})
            if (!_.isEmpty(model)) {
              await bimplusViewer.showModel(props.bimplusProjectId, model);
              model.setVisible(true);
              bimplusViewer.isolateObjects(props.guids);
            }
          }
        } else if(routeFrom === 'projectSettings') {
          const orderId = _.get(route.query, 'orderId', '');
          const modelId = _.get(route.query, 'modelId', '');
          const projectGuids = _.get(route.query, 'projectGuids', false);

          if(projectGuids) {
            data.guidsList = await BimPlus.requestGuids(projectId, true);
          } else {
            data.guidsList = await BimPlus.requestGuids(orderId, false);
          }
          if(modelId) {
            const model = _.find(data.projectModels, {id : modelId});
            data.projectModels = [model];
            if (!_.isEmpty(model)) {
              data.setModelVisible = true;
            }
          }
        } else if(props.addObjectsBySelection) {
          const model = _.find(data.projectModels, {id : props.modelId});
          data.projectModels = [model];
          if (!_.isEmpty(model)) {
            await bimplusViewer.showModel(data.bimplusProjectId, model);
            model.setVisible(true);      
            bimplusViewer.isolateHide(props.guids);
          }
        }
        window.addEventListener('resize', resizeViewer);

      } catch (e) {
        console.log('Error: ', e);
      } finally {
        data.isLoading = false;
        data.projectModelsFetched = true;
      }
    });

    return{
      ...toRefs(data),
      refreshToken,
      resetView,
      toggleFilterModal,
      toggleModelSettingsModal,
    }

  },
};

</script>
<style scoped>
.mf-viewer-wrapper{
  height: 100vh;
  position: relative;
  z-index: 0;
}
.hide-sidemenu {
  left: 0;
}
</style>